// components/OrderSummaryCards.jsx

import React from "react";

import {
  FiCreditCard,
  FiDollarSign,
  FiPackage,
  FiTruck,
} from "react-icons/fi";

import {
  formatCurrency,
  formatNumber,
} from "../utils/orderHelpers";


const OrderSummaryCards = ({
  summary,
}) => {
  const totalOrders =
    Number(
      summary?.totalOrders ||
      0
    );

  const totalAmount =
    Number(
      summary?.totalAmount ||
      0
    );

  const paidCount =
    Number(
      summary
        ?.payments
        ?.paid
        ?.count ||
      0
    );

  const paidAmount =
    Number(
      summary
        ?.payments
        ?.paid
        ?.amount ||
      0
    );

  const pendingCount =
    Number(
      summary
        ?.statuses
        ?.pending ||
      0
    );

  const shippedCount =
    Number(
      summary
        ?.statuses
        ?.shipped ||
      0
    );

  return (
    <div
      className="order-summary-grid"
    >
      <div
        className="order-summary-card primary"
      >
        <span
          className="order-summary-icon"
        >
          <FiPackage />
        </span>

        <div>
          <small>
            Total Orders
          </small>

          <strong>
            {formatNumber(
              totalOrders
            )}
          </strong>

          <span>
            Selected period
          </span>
        </div>
      </div>


      <div
        className="order-summary-card success"
      >
        <span
          className="order-summary-icon"
        >
          <FiDollarSign />
        </span>

        <div>
          <small>
            Order Value
          </small>

          <strong>
            {formatCurrency(
              totalAmount
            )}
          </strong>

          <span>
            Gross order value
          </span>
        </div>
      </div>


      <div
        className="order-summary-card paid"
      >
        <span
          className="order-summary-icon"
        >
          <FiCreditCard />
        </span>

        <div>
          <small>
            Paid Orders
          </small>

          <strong>
            {formatNumber(
              paidCount
            )}
          </strong>

          <span>
            {formatCurrency(
              paidAmount
            )}
          </span>
        </div>
      </div>


      <div
        className="order-summary-card warning"
      >
        <span
          className="order-summary-icon"
        >
          <FiTruck />
        </span>

        <div>
          <small>
            Needs Attention
          </small>

          <strong>
            {formatNumber(
              pendingCount
            )}
          </strong>

          <span>
            {formatNumber(
              shippedCount
            )} shipped
          </span>
        </div>
      </div>
    </div>
  );
};


export default
  OrderSummaryCards;